import { Component, ElementRef, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { AddOrEditMenuItemModel } from 'src/app/pos-panel/models/menu-items/add-or-edit-menu-item.model';
import { MessageService } from "primeng/api";
import { MenuService } from "../../../services/menus/menu.service";
import { CategoryModel } from "../../../models/categories/category.model";
import { SubcategoryModel } from "../../../models/subcategories/subcategory.model";
import {
  CropAndCompressImageDialogComponent
} from "../../../../share-modul/components/crop-and-compress-image-dialog/crop-and-compress-image-dialog.component";
import { CroppedImage } from "../../../../share-modul/models/image/cropped-image.model";
import { InventoryItemModel } from 'src/app/pos-panel/models/inventory/inventory-item.model';
import { InventoryService } from 'src/app/pos-panel/services/inventory/inventory.service';
import { AddIngredientItemComponent } from '../add-ingredient-item/add-ingredient-item/add-ingredient-item.component';
import { SupplyModel } from 'src/app/pos-panel/models/menu-items/supply-model';
import { SupplyItemModel } from 'src/app/pos-panel/models/menu-items/supply-item.model';
import { VenueService } from "../../../services/venues/venue.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-add-or-edit-menu-item',
  templateUrl: './add-or-edit-menu-item.component.html',
  styleUrls: ['./add-or-edit-menu-item.component.scss']
})
export class AddOrEditMenuItemComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public pictureIsWrongFormat: boolean = false;
  public addOrEditMenuItemModel: AddOrEditMenuItemModel = new AddOrEditMenuItemModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/logo/category.png';
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public enableEdit: boolean = false;
  public menuItemId: string;
  public companyId: string;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public categoriesDropdownHelperModels: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public subcategoriesDropdownHelperModels: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public taxRatesDropdownHelperModels: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public divisionsDropdownHelper: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();

  public unitsOfMeasurements: Array<any>;
  public inventoryItemsList: Array<InventoryItemModel>;
  particulars: any[] = [];
  //#endregion

  //#region Constructor
  constructor(
    private openFile: ElementRef,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private menuService: MenuService,
    private venueService: VenueService,
    public dialogService: DialogService,
    private inventoryService: InventoryService,
    public translate: TranslateService
  ) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    if (this.config.data != undefined && this.config.data.menuitem) {
      this.menuItemId = this.config.data.menuitem.id;
      this.enableEdit = true;
      this.addOrEditMenuItemModel = JSON.parse(JSON.stringify(this.config.data.menuitem));
      this.addOrEditMenuItemModel.subvenueIds = this.config.data.menuitem.subVenues.map((x: any) => x.subVenueId);
    }
    if (this.config.data != undefined && this.config.data.companyId) {
      this.companyId = this.config.data.companyId;
    }
    if (this.config.data != undefined && this.config.data.menuItemTypeId) {
      this.addOrEditMenuItemModel.menuItemTypeId = this.config.data.menuItemTypeId;
    }
    if(this.config.data != undefined && this.config.data.menuItemTypeId && !this.config.data.menuitem){
      this.addOrEditMenuItemModel.supplies = new Array<SupplyModel>();
    }
    this.inventoryItemsList = new Array<InventoryItemModel>();
  }

  ngOnInit(): void {
    this.loadCategoriesForCompany();
    this.loadTaxRatesForCompany();
    this.loadDivisionsForCompany();
    this.listUnitsOfMeasurements();
    this.particulars.push('');
  }
  //#endregion

  //#region Public Methods
  addMenuItem(model: AddOrEditMenuItemModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage().toString();
    model.companyId = this.companyId;
    model.companyMenuCategoryId = model.subcategoryId ? model.subcategoryId : model.categoryId;

    if (model && (!model.name || model.name == "")) {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.companyMenuCategoryId || model.companyMenuCategoryId == "")) {
      this.errorModel['CategoryId'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.price) {
      this.errorModel['Price'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.taxRateId) {
      this.errorModel['Tax'] = this.requiredFieldErrorMessage;
    }
    if (!this.filePicture) {
      this.errorModel['Image'] = this.requiredFieldErrorMessage;
    }

    if (model && (!model.subvenueIds || model.subvenueIds.length === 0)) {
      this.errorModel['SubvenueIds'] = this.requiredFieldErrorMessage;
    }

    if (model && (!model.supplies || model.supplies.length === 0)) {
      this.errorModel['Supplies'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      if(model.description != null ){
        model.description = model.description.replace(/\n/g, ' ');
      }
      this.spinner = true;
      this.menuService.createMenuItem(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
    }
  }

  editMenuItem(model: AddOrEditMenuItemModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage().toString();
    model.companyId = this.companyId;
    model.companyMenuCategoryId = model.subcategoryId ? model.subcategoryId : model.categoryId;

    if (model && (!model.name || model.name == "")) {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.companyMenuCategoryId || model.companyMenuCategoryId == "")) {
      this.errorModel['CategoryId'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.price) {
      this.errorModel['Price'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.taxRateId) {
      this.errorModel['Tax'] = this.requiredFieldErrorMessage;
    }
    if (!this.filePicture && (!model.pictureURL || model.pictureURL == "")) {
      this.errorModel['Image'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.subvenueIds || model.subvenueIds.length === 0)) {
      this.errorModel['SubvenueIds'] = this.requiredFieldErrorMessage;
    }

    if (model && (!model.supplies || model.supplies.length === 0)) {
      this.errorModel['Supplies'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      if(model.description != null ){
        model.description = model.description.replace(/\n/g, ' ');
      }
      this.spinner = true;
      this.menuService.editMenuItem(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
    }
  }

  loadCategoriesForCompany() {
    this.categoriesDropdownHelperModels = new Array<DropdownHelperModel>();
    this.spinner = true;
    this.menuService.listCategoryForCompany(this.companyId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.categoriesDropdownHelperModels = response.map((x: CategoryModel) => ({id: x.id, name: x.name}));

          if (this.enableEdit) {
            this.fetchSubcategories(response);
          }
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  listUnitsOfMeasurements(){
    this.inventoryService.listUnitOfMeasurements().subscribe((response)=>{
      this.unitsOfMeasurements = response;
    });
  }

  reloadSubcategories(selectedCategory: any, preselectedSubcategory: SubcategoryModel | undefined = undefined) {
    this.spinner = true;
    this.menuService.listSubcategoryForCategory(selectedCategory.value ? selectedCategory.value : selectedCategory)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.subcategoriesDropdownHelperModels = response.map((x: SubcategoryModel) => ({id: x.id, name: x.name}));
          this.addOrEditMenuItemModel.subcategoryId = undefined;
          if (preselectedSubcategory !== undefined) {
            this.addOrEditMenuItemModel.subcategoryId = preselectedSubcategory.id;
          }
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  fetchSubcategories(categories: Array<CategoryModel>) {
    if (categories.find(x => x.id === this.addOrEditMenuItemModel.companyMenuCategoryId)) {
      this.addOrEditMenuItemModel.categoryId = this.addOrEditMenuItemModel.companyMenuCategoryId;
      this.reloadSubcategories(this.addOrEditMenuItemModel.companyMenuCategoryId);
    } else {
      this.menuService.listSubcategoryForCompany(this.companyId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            let subcategory: SubcategoryModel = response.find((x: SubcategoryModel) => x.id === this.addOrEditMenuItemModel.companyMenuCategoryId);
            if (subcategory !== undefined) {
              this.addOrEditMenuItemModel.categoryId = subcategory.parentId;
              this.reloadSubcategories(subcategory.parentId, subcategory);
            }
          },
          error: errorResponse => {
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
    }
  }

  loadInventoryItemsForCompany(event: any){
    if(String(event.query).length >= 2){
      this.inventoryService.listSuppliesForCompany(this.companyId,event.query)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response)=>{
          this.inventoryItemsList = response;
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
    }

  }

  trackByFn(index: any, item: any) {
    return index;
  }

  pushIngrediantItem(index: any){
    if(this.inventoryItemsList.includes(this.particulars[index])){
      const supply:SupplyModel = new SupplyModel();
      supply.supplyId = this.particulars[index].id;
      supply.quantity = this.particulars[index].quantity;
      supply.supply = this.particulars[index];
      supply.supply.unitOfMeasurementShortName = this.unitsOfMeasurements
        .find(x => x.id === supply.supply.unitOfMeasurementId).shortName;
      this.addOrEditMenuItemModel.supplies.push(supply)
      this.particulars.pop();
      this.particulars.push('');
    } else {
      this.addIngredientItem(this.particulars[index]);
    }
  }
  removeIngredient(ingredient: SupplyModel){
    const index = this.addOrEditMenuItemModel.supplies.indexOf(ingredient);
    this.addOrEditMenuItemModel.supplies.splice(index,1)
  }

  addIngredientItem(ingredient: string) {
    const ref = this.dialogService.open(AddIngredientItemComponent, {
      data: {
        companyId: this.companyId,
        supplyName: ingredient,
      },
      header: this.translate.instant('INGREDIENT_ITEM.ADD_INVENTORY_ITEM'),
      width: '685px',
      styleClass: 'dialog_menuIngredientsItems mb_15'
    });
    ref.onClose.subscribe((item: SupplyItemModel) => {
      if (item) {
        const supply:SupplyModel = new SupplyModel();
        supply.supplyId = item.id;
        supply.quantity = item.quantity;
        supply.supply = item;
        supply.supply.unitOfMeasurementShortName = item.unitOfMeasurementShortName;
        this.addOrEditMenuItemModel.supplies.push(supply)
        this.particulars.pop();
        this.particulars.push('');
      }
    });
  }

  determineImageUrl(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }

  languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }

  cropAndCompressImageDialog(): void {
    const ref = this.dialogService.open(CropAndCompressImageDialogComponent, {
      data: {
        imagePath: this.imagePath
      },
      styleClass: 'dialog_long, mb_5, ml_200, dialog_menuItems_cropper'
    });
    ref.onClose.subscribe((image: CroppedImage) => {
      if (image) {
        this.filePicture = image.imageFile;
        this.addOrEditMenuItemModel.pictureURL = image.imagePath;
      }
    });
  }

  public loadTaxRatesForCompany(): void {
    this.menuService.listAllTaxRatesForCombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.taxRatesDropdownHelperModels = response.map((x: CategoryModel) => ({id: x.id, name: x.name}));
          if (!this.enableEdit) {
            const defaultTaxRate = response.find((a: any) => a.isDefault);
            if (defaultTaxRate) {
              this.addOrEditMenuItemModel.taxRateId = defaultTaxRate.id;
            }
          }
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public loadDivisionsForCompany(): void {
    this.menuService.loadAllDivisionsForCombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.divisionsDropdownHelper = response.map((x: any) => ({id: x.id, name: x.nameWithVenueName}));
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }

  public getMeasurementUnit(inventoryItemsList: Array<InventoryItemModel>, id: string) {
    return this.unitsOfMeasurements.find(x => x.id === inventoryItemsList.find(x => x.id === id)!.unitOfMeasurementId)!.shortName;
  }
  //#endregion
}
